import React,{useState, useEffect}  from 'react';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button'
import Sides from '../Bars/Csidebar';
import { Helmet } from "react-helmet";
function Cscopevar(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
       <Sides/>
       <Helmet>
 
<title>Scope of variable in a c tutorial For Beginners</title>
<meta name="description" content="scope of the variable in a c tutorial for beginners.Scope of the variable in a c programming language, CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners" />
<meta name="keywords" content="codeexampler,programming language,tutorial for begineers,learn code in free,c programming tutorial for beginners,learn code in free online,c scope of variable,c scope of variables,scope of variable in c,scope of variables in c pdf,scope of a variable in c,what is scope of variable in c,c programming scope of variables,c scope of variable declared in if statement,scope of variable declared in for loop c,scope of variables in c sharp,scope of variable in c language" />
<link rel="canonical" href="https://www.codeexampler.com/c-scope-of-variable"/>
</Helmet>

<div className='lg:pl-56'>

    <h1 className="m-4 mh1">
Scope of Variable in C Tutorial
</h1>
<div className="first">
        <a href="/c-variable">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/c-element">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <h2 className="mt-4 mh2">A Local variable in C Computer language:</h2>
<p className="mt-4 para">1, These types of variables in the c programming language defined inside a function<br/>
2, It Can’t use it from outside that function.<br/>
3, The initial value will be garbage<br/>
</p>


<h2 className='headings'>Q-Write a Program Local variable in c Example?</h2>
       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight:"100vh"}}>
          <code >
            {"\n"}
                <span className="qwerty-7">#include </span>
                <span className="qwerty-3">&#60;</span>
                <span className="qwerty-5">stdio.h</span>
                <span className="qwerty-3">&#62; </span>
            {"\n"}
                <span className="qwerty-5">int</span>
                <span className="qwerty-10"> i</span>
                <span className="qwerty-3">;</span>
            {"\n"}{"\n"}
                <span className="qwerty-5">void </span>
                <span className="qwerty-7">show</span>
                <span className="qwerty-3"> ()</span>
            {"\n"}{"\n"}
                <span className="qwerty-3" > &#123; </span>
            {"\n"}{"\n"}
                <span className="qwerty-7">     printf</span>
                <span className="qwerty-3">("</span>
                <span className="qwerty-4">%d</span>
                <span className="qwerty-3">"",</span>
                <span className="qwerty-10">i</span>
                <span className="qwerty-3">);</span>            
            {"\n"}{"\n"}
                <span className="qwerty-3" >&#125;</span>       
            {"\n"}{"\n"}
                <span className="qwerty-5">void </span>
                <span className="qwerty-10">main</span>
                <span className="qwerty-3"> ()</span>
            {"\n"}{"\n"}
                <span className="qwerty-3" > &#123; </span>
            {"\n"}{"\n"}
                <span className="qwerty-5">    int</span>
                <span className="qwerty-10"> i</span>
                <span className="qwerty-3">=</span>
                <span className="qwerty-10"> 10</span>
                <span className="qwerty-3">;</span>
            {"\n"}{"\n"}
                <span className="qwerty-10">    i</span>
                <span className="qwerty-11">+</span>
                <span className="qwerty-11">+</span>
                <span className="qwerty-3"> ;</span>
            {"\n"}{"\n"}
                    <span className="qwerty-7">    show</span>
                    <span className="qwerty-3">()</span>
                    <span className="qwerty-3">;</span>            
            {"\n"}{"\n"}
                <span className="qwerty-3">&#125;</span>
        </code>{"\n"}{"\n"}
        </pre>
        </div>          
        <h4 className='headings'>Output :</h4>
         <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
          <pre style={{maxHeight:"100vh"}}>
                <code >                    
                    {"\n"}
                        <span className="qwerty-10">11</span>                    
                </code>{"\n"}{"\n"}
                </pre>
                </div>

<h2 className='headings'>Q-Write a Program Global variable in c Example?</h2>
       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight:"100vh"}}>
          <code >
            {"\n"}
                <span className="qwerty-7">#include </span>
                <span className="qwerty-3">&#60;</span>
                <span className="qwerty-5">stdio.h</span>
                <span className="qwerty-3">&#62; </span>
                   {"\n"}
                <span className="qwerty-7">#include </span>
                <span className="qwerty-3">&#60;</span>
                <span className="qwerty-5">conio.h</span>
                <span className="qwerty-3">&#62; </span>
                        {"\n"}{"\n"}
                <span className="qwerty-5">int</span>
                <span className="qwerty-10"> i</span>
                <span className="qwerty-3">=</span>
                <span className="qwerty-10"> 50</span>
                <span className="qwerty-3">;</span>
                        {"\n"}{"\n"}
                <span className="qwerty-5">void </span>
                <span className="qwerty-7">show</span>
                <span className="qwerty-3"> ()</span>
                        {"\n"}{"\n"}
                <span className="qwerty-3" > &#123; </span>
                        {"\n"}{"\n"}
                <span className="qwerty-7">     printf</span>
                <span className="qwerty-3">("</span>
                <span className="qwerty-4">%d</span>
                <span className="qwerty-2">\n</span>
                <span className="qwerty-3">",</span>
                <span className="qwerty-10">i</span>
                <span className="qwerty-3">);</span>
                        {"\n"}{"\n"}
                <span className="qwerty-10">     i</span>
                <span className="qwerty-3">=</span>
                <span className="qwerty-10">40</span>
                <span className="qwerty-3">;</span>
                        {"\n"}{"\n"}
                <span className="qwerty-3" >&#125;</span>              
            {"\n"}{"\n"}
                <span className="qwerty-5">void </span>
                <span className="qwerty-10">main</span>
                <span className="qwerty-3"> ()</span>            
            {"\n"}{"\n"}
                <span className="qwerty-3" > &#123; </span>
                            {"\n"}{"\n"}
                <span className="qwerty-10">    i</span>
                <span className="qwerty-11">+</span>
                <span className="qwerty-11">+</span>
                <span className="qwerty-3"> ;</span>
                          {"\n"}{"\n"}
                    <span className="qwerty-7">     show</span>
                    <span className="qwerty-3">()</span>
                    <span className="qwerty-3">;</span>                  
                     {"\n"}{"\n"}
                <span className="qwerty-7">     printf</span>
                <span className="qwerty-3">("</span>
                <span className="qwerty-4">%d</span>
                <span className="qwerty-3">",;</span>
                <span className="qwerty-10">i</span>
                <span className="qwerty-3">);</span>                
            {"\n"}{"\n"}
                <span className="qwerty-3">&#125;</span>
             </code>{"\n"}{"\n"}
        </pre>
        </div>          
        <h4 className='headings'>Output :</h4>
         <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
            <pre style= {{ maxHeight:"100vh" }}>
                <code >
                {"\n"}
                        <span className="qwerty-10">51</span>
                    {"\n"}{"\n"}
                        <span className="qwerty-10">40</span>
                        {"\n"}{"\n"}
                </code>
                </pre>
                </div>

<p className="mt-4 para"><span className="bold">Ans-</span>error ! Because undefined  symbol i in show() function</p>

<h2 className="mt-4 mh2">Global variable in C computer language:
</h2>

<p className="mt-4 para">1, Global variable in C programming language is defined from outside all functions and can be used anywhere in the program<br/>
2, The initial value will be zero.<br/>
</p>




<h2 className="mt-4 mh2">Static Variable in C programming language:</h2>
<p className="mt-4 para">1, These types of variables defines inside a function with the static keyword.<br/>
2, Variable can’t rationalize 2, Value of the static Variable in a different function call.<br/>
3, Initial value will be zero<br/>
</p>



<h2 className='headings'>Q-Write a Static Program variable in c Example?</h2>
       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight:"100vh"}}>
          <code >
            {"\n"}
                <span className="qwerty-7">#include </span>
                <span className="qwerty-3">&#60;</span>
                <span className="qwerty-5">stdio.h</span>
                <span className="qwerty-3">&#62; </span>
            {"\n"}
                <span className="qwerty-7">#include </span>
                <span className="qwerty-3">&#60;</span>
                <span className="qwerty-5">conio.h</span>
                <span className="qwerty-3">&#62; </span>
            {"\n"}{"\n"}
                <span className="qwerty-5">int</span>
                <span className="qwerty-10"> i</span>
                <span className="qwerty-3">;</span>
            {"\n"}{"\n"}
                <span className="qwerty-5">void </span>
                <span className="qwerty-7">show</span>
                <span className="qwerty-3"> ()</span>
            {"\n"}{"\n"}
                <span className="qwerty-3" > &#123; </span>
            {"\n"}{"\n"}
                <span className="qwerty-9">   static </span>
                <span className="qwerty-5">int</span>
                <span className="qwerty-10"> i </span>
                <span className="qwerty-3">=</span>
                <span className="qwerty-10"> 60</span>
                <span className="qwerty-3">;</span>
            {"\n"}{"\n"}
                <span className="qwerty-7">   printf</span>
                <span className="qwerty-3">("</span>
                <span className="qwerty-4">%d</span>
                <span className="qwerty-3">"",</span>
                <span className="qwerty-10">i</span>
                <span className="qwerty-3">);</span>
            {"\n"}{"\n"}
            <span className="qwerty-10">   i</span>
            <span className="qwerty-3">+</span>
            <span className="qwerty-3">+</span>
                <span className="qwerty-3">;</span>
            {"\n"}{"\n"}
                <span className="qwerty-3" >&#125;</span>       
            {"\n"}{"\n"}
                <span className="qwerty-5">void </span>
                <span className="qwerty-10">main</span>
                <span className="qwerty-3"> ()</span>
            {"\n"}{"\n"}
                <span className="qwerty-3" > &#123; </span>
            {"\n"}{"\n"}
                <span className="qwerty-7">    show</span>
                    <span className="qwerty-3">()</span>
                    <span className="qwerty-3">;</span>
             {"\n"}{"\n"}
                <span className="qwerty-7">    show</span>
                <span className="qwerty-3">()</span>
                <span className="qwerty-3">;</span>
         {"\n"}{"\n"}
            <span className="qwerty-7">    show</span>
            <span className="qwerty-3">()</span>
            <span className="qwerty-3">;</span>             
            {"\n"}
                <span className="qwerty-3">&#125;</span>
        </code>{"\n"}{"\n"}
        </pre>
        </div>          
        <h4 className='headings'>Output :</h4>
         <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
          <pre style={{maxHeight:"100vh"}}>
                <code >
                    
                    {"\n"}
                        <span className="qwerty-10">60</span>                   
                    {"\n"}{"\n"}
                        <span className="qwerty-10">61</span>
                    {"\n"}{"\n"}
                        <span className="qwerty-10">62</span>                 
                </code>{"\n"}{"\n"}
                </pre>
                </div>


<h1 className="mt-5">  </h1>
<div className="back">
        <a href="/c-variable">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/c-element">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div></div>
)

}
export default Cscopevar;